
/**
 * Chat thread created or existing returned with full details
 */
export type CreateChatThreadResponseAllOfFive = { [key: string]: unknown };
